import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { withI18n } from 'lingui-react';

import Page from 'elements/Page';
import WizardController from 'containers/WizardController';

import messages from './messages';

export function ServiceRequestCreatePage({
  i18n,
}) {
  return (
    <Page name="service-request-wizard-page">
      <Helmet
        title={i18n._(messages.title)}
        meta={[
          { name: 'description', content: i18n._(messages.description) },
        ]}
      />
      <WizardController configKey="SERVICE_REQUEST_WIZARD" />
    </Page>
  );
}

ServiceRequestCreatePage.propTypes = {
  i18n: PropTypes.shape({
    _: PropTypes.func.isRequired,
  }).isRequired,
};

export default withI18n()(ServiceRequestCreatePage);



// WEBPACK FOOTER //
// ./containers/ServiceRequestCreatePage/index.js